module.exports = __webpack_public_path__ + "img/85.6c5f2205.png";